<template>
  <div
    class="modal fade"
    id="applianceModal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content px-md-5 py-md-4">
        <div class="modal-header border-0">
          <h2 class="h2">{{ heading }}</h2>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- forms and form select -->
          <template v-if="!isCompleted">
            <!-- select form type -->
            <template v-if="!selectedForm">
              <div
                class="d-flex align-items-start justify-content-between flex-wrap"
              >
                <div class="mb-4">
                  <button
                    class="btn btn-secondary mb-4"
                    @click.prevent="selectForm('person')"
                  >
                    Žádost o individuální příspěvek – fyzická osoba
                  </button>
                  <template v-if="$attrs['individual-form-document'].length">
                    <p class="font-size-lg text-primary">
                      Případně si můžete formulář stáhnout:
                    </p>
                    <p class="font-size-lg">
                      <a
                        class="text-secondary"
                        :href="$attrs['individual-form-document']"
                        download
                        >Žádost o individuální příspěvek - fyzická osoba.pdf</a
                      >
                    </p>
                  </template>
                </div>
                <div class="mb-4">
                  <button
                    class="btn btn-secondary mb-4"
                    @click.prevent="selectForm('company')"
                  >
                    Žádost o poskytnutí příspěvku - právnická osoba
                  </button>
                  <template v-if="$attrs['company-form-document'].length">
                    <p class="font-size-lg text-primary">
                      Případně si můžete formulář stáhnout:
                    </p>
                    <p class="font-size-lg">
                      <a
                        class="text-secondary"
                        :href="$attrs['company-form-document']"
                        download
                        >Žádost o poskytnutí příspěvku - právnická osoba.pdf</a
                      >
                    </p>
                  </template>
                </div>
              </div>
            </template>

            <!-- form type - person -->
            <Person-Form
              v-if="selectedForm === 'person'"
              @done="isCompleted = true"
            ></Person-Form>

            <!-- form type - company -->
            <Company-Form
              v-if="selectedForm === 'company'"
              @done="isCompleted = true"
            ></Company-Form>
          </template>

          <!-- form completed -->
          <template v-else>
            <h2 class="h4 text-secondary mb-5">
              Formulář byl v pořádku odeslán. Děkujeme a budeme Vás v nejbližší
              době kontaktovat.
            </h2>

            <h2 class="h3 mb-3">Hodnocení žádostí - Kritéria hodnocení</h2>

            <p class="mb-3">
              Žádosti schvaluje správní rada.<br />
              Příspěvek nadačního fondu není až do podpisu smlouvy oběma
              stranami nárokovatelný. Správní rada má právo si vyžádat další
              podklady, které jí pomohou k rozhodnutí o přidělení podpory.
            </p>

            <p class="text-primary">
              <strong>V hodnocení se zohledňuje zejména:</strong>
            </p>

            <ul class="my-3">
              <li class="HelpItem mb-2">
                termín podání žádosti (dřívější datum žádosti se zohlední)
              </li>
              <li class="HelpItem mb-2">
                úplnost a správnost vyplnění žádosti
              </li>
              <li class="HelpItem mb-2">
                prokazatelný zájem o práci ve zdravotnictví v ČR, tj.
                doložitelná doba aktivního působení ve zdravotnictví (vč.
                odborné pedagogické činnosti) – nevztahuje se na studenty
                prezenčních studijních programů
              </li>
              <li class="HelpItem mb-2">
                zaměstnanecký poměr vůči EUC (a jeho rozsah, u studentů
                „brigády“)
              </li>
              <li class="HelpItem mb-2">
                přínos pro zdravotníky zejména skupiny EUC
              </li>
              <li class="HelpItem mb-2">míra finanční spoluúčasti žadatele</li>
              <li class="HelpItem mb-2">
                aktuální potřebnost projektu a jeho pozitivní vliv/přínos
                zdravotnictví v ČR, zejména v oblasti ošetřovatelství,
              </li>
              <li class="HelpItem mb-2">
                dosavadní zkušenosti předkladatele v oblasti, ve které žádost
                podává.
              </li>
            </ul>

            <p class="mb-4">
              Upřednostňují se žádosti nelékařských zdravotnických pracovníků a
              projekty zaměřené na podporu jejich vzdělávání a působení ve
              zdravotnictví v ČR.
            </p>

            <h2 class="h3 mb-3">Uzavření smlouvy</h2>

            <p>
              Předkladatelé, jejichž žádost byla schválena, uzavřou s nadačním
              fondem smlouvu, v níž se zavazují použít finanční prostředky k
              dohodnutým účelům a za předem stanovených podmínek.
            </p>

            <div class="mt-4 text-right">
              <button
                class="btn btn-secondary px-5"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                Zavřít
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonForm from './PersonForm.vue'
import CompanyForm from './CompanyForm.vue'

export default {
  components: {
    PersonForm,
    CompanyForm
  },
  data () {
    return {
      selectedForm: '',
      isCompleted: false
    }
  },
  methods: {
    selectForm (form) {
      this.selectedForm = form
    },
    resetForm () {
      this.selectedForm = ''
      this.isCompleted = false
    }
  },
  computed: {
    heading () {
      if (this.selectedForm) {
        if (this.selectedForm == 'person') {
          return 'Žádost o individuální příspěvek - fyzická osoba'
        } else if (this.selectedForm == 'company') {
          return 'Žádost o poskytnutí příspěvku - právnická osoba'
        }
      } else {
        return 'Chci odeslat žádost'
      }
    }
  },
  mounted () {
    // focus fix for modal inputs
    let pageScroll = 0

    $('#applianceModal').on('show.bs.modal', () => {
      // when modal is opened, go to top of page
      pageScroll = $(window).scrollTop()
      window.scroll({
        top: 0
      })
    })

    $('#applianceModal').on('hide.bs.modal', () => {
      // when it's closed, return back
      window.scroll({
        top: pageScroll
      })
    })
    // --- focus fix for modal inputs ---

    $('#applianceModal').on('hidden.bs.modal', () => {
      this.resetForm()
    })
  }
}
</script>
